import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { registerGlobalLoader } from "../services/globalLoader";

const AppLoadingContext = createContext({
  isLoading: false,
});

export function AppLoadingProvider({ children }) {
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    registerGlobalLoader({
      increment: () => setActiveCount((c) => c + 1),
      decrement: () => setActiveCount((c) => Math.max(0, c - 1)),
    });
  }, []);

  const value = useMemo(
    () => ({
      isLoading: activeCount > 0,
      activeCount,
    }),
    [activeCount]
  );

  return <AppLoadingContext.Provider value={value}>{children}</AppLoadingContext.Provider>;
}

export function useAppLoading() {
  return useContext(AppLoadingContext);
}

